<script>
    import {mapState} from "vuex";
    import { cloneDeep } from 'lodash';
    import PricePackageForm from "./pricePackageForm";

    export default {
        name: "pricingPackages",
        components: {PricePackageForm},
        data () {
            return {
                showNewModal: false,
                showEditModal: false,
                editPackage: {},
                packages: [],
                newPackageTotalPriceError: false,
                newPackageQuantityError:[],
                newPackageFormError: false,
                editPackageTotalPriceError: false,
                editPackageQuantityError:[],
                editPackageFormError: false
            };
        },
        watch: {
            pricePackages: {
               handler(newValue) {
                   this.packages = cloneDeep(newValue);
               },
                   deep: true
               }
        },
        computed: {
            ...mapState('pricing', {
                pricePackages: (state) => state.pricePackages,
                pricelist: (state) => state.pricelist
            })
        },
        created () {
            this.packages = cloneDeep(this.pricePackages.map((item) => item));
        },
        methods: {
            async createPackage (newPackage) {
                try{
                    await this.$store.dispatch('pricing/createPriceItem', {payload: newPackage, type: 'pricePackages'});
                } catch (err) {
                    console.log(err);
                } finally {
                    this.closeNewModal();
                }
            },
            isPackageValid (packageName) {
                if (this[packageName].total_net_price === '' || (/^\d+$/.test(this[packageName].total_net_price.toString()) && this[packageName].total_net_price <= 0)) {
                    this[`${packageName}TotalPriceError`] = true;
                }
                for (let i = 0; i < this[packageName].price_package_items.length; i++) {
                    if (this[packageName].price_package_items[i].quantity !== '' &&
                        /^\d+$/.test(this[packageName].price_package_items[i].quantity.toString()) &&
                        this[packageName].price_package_items[i].quantity  <= 0) {
                        this[`${packageName}QuantityError`][i] = true;
                    }
                }
                //check if price packages contains empty or invalid field
                for (let i = 0; i < this[packageName].price_package_items.length; i++) {
                    if (this[packageName].price_package_items[i].post_type === '' ||
                        this[packageName].price_package_items[i].social_network === '' ||
                        !(/^\d+$/.test(this[packageName].price_package_items[i].quantity.toString()) &&
                            this[packageName].price_package_items[i].quantity > 0)) {
                        return false;
                    }
                }
                return this[packageName].name !== '' && (/^\d+$/.test(this[packageName].total_net_price.toString()) && this[packageName].total_net_price > 0) && this[packageName].currency !== '';
            },
            edit (pack) {
                this.editPackage = cloneDeep(pack);
                this.showEditModal = true;
            },
            async deletePackage (pack) {
                try{
                    await this.$store.dispatch('pricing/deletePricePackage', {packageId: pack._id, type: 'pricePackages' });
                } catch (err) {
                    console.log(err)
                }
            },
            closeNewModal () {
                this.showNewModal = false;
            },
            closeEditModal () {
                this.editPackage = {};
                this.showEditModal = false;
            },
            async updatePackage (newPackage) {
                try{
                    await this.$store.dispatch('pricing/updatePriceItem', {packageId: newPackage._id, payload: newPackage, type: 'pricePackages'});
                } catch (err) {
                    console.log(err)
                } finally {
                    this.closeEditModal();
                }
            },
            sum (pack) {
                return pack.price_package_items.reduce((acc, item) => acc + item.net_price * item.quantity, 0);
            },
            percentage (pack) {
                let diff = pack.total_net_price - this.sum(pack);
                let percentage = diff / this.sum(pack)   * 100;
                return parseInt(percentage, 10);
            }
        }
    }
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12 text-right">
                <button v-if="pricelist.length" @click="showNewModal = true" class="btn btn-primary mt-4"> <i class="bx bx-plus" style="font-size: 16px; vertical-align: middle;"></i>New package</button>
                <div v-else class="text-center mt-4 mb-2 font-size-16">You'll be able to create a price package once you have at least one price specified.</div>
            </div>
            <div v-for="(pack, index) in packages" :key="pack._id" class="col-12 col-md-12 col-xl-12">
                <div class="tab-section p-3 mt-4 full-height-card">
                    <div class="row align-items-center mb-2">
                        <div class="col">
                            <h5 class="mb-0"> {{ pack.name }}</h5>
                        </div>
                        <div class="col-auto d-flex align-items-center">
                            <button @click="edit(pack)"  class="btn btn-outline-warning btn-sm mr-2"> <i class="bx bxs-edit-alt mr-1 align-middle font-size-16"></i> Edit</button>
                            <button @click="deletePackage(pack)"  class="btn btn-outline-danger btn-sm"> <i class="bx bx-x mr-1 align-middle font-size-16"></i> Remove </button>
                        </div>
                    </div>
                    <div>
                        <div class="p-1 price-item pricing-header-row mb-1 d-none d-md-block">
                            <div class="row align-items-center">
                                <div class="col-12 col-md text-center">
                                    <p class="text-muted mb-0">{{ $t('Platform')}}</p>
                                </div>
                                <div class="col-6 col-md text-center">
                                    <p class="text-muted mb-0">{{ $t('Post type')}}</p>
                                </div>
                                <div class="col text-center">
                                    <p class="text-muted mb-0">{{ $t('Giveaway')}}</p>
                                </div>
                              <div class="col text-center">
                                <p class="text-muted mb-0">{{ $t('Event')}}</p>
                              </div>
                                <div class="col-6 col-md text-center">
                                    <p class="text-muted mb-0">{{ $t('Price')}}</p>
                                </div>
                                <div class="col-6 col-md text-center">
                                    <p class="text-muted mb-0">{{ $t('Quantity')}}</p>
                                </div>
                                <div class="col-6 col-md-auto text-center">
                                    <div class="price-container">
                                        <p class="text-muted mb-0">{{ $t('Total price')}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-section p-1 price-item" v-for="price in pack.price_package_items" :key="price.post_type + price.social_network + index">
                            <div class="row align-items-center">
                                <div class="order-1 col-auto col-6 col-md text-center mt-2 mt-md-0">
                                    <p class="text-muted d-md-none mb-1">{{ $t('Platform')}}</p>
                                    <div class="social-image-container d-flex align-items-center justify-content-center">
                                        <img v-if="price.social_network === 'instagram'" src="@/assets/images/brands/instagram.png" class="img-fluid" style="width:28px;" alt="">
                                        <img v-if="price.social_network === 'facebook'" src="@/assets/images/brands/facebook.png" class="img-fluid" style="width:28px;" alt="">
                                        <img v-if="price.social_network === 'youtube'" src="@/assets/images/brands/youtube.png" class="img-fluid" style="width:28px;" alt="">
                                        <img v-if="price.social_network === 'blog'" src="@/assets/images/brands/analytics-logo.png" class="img-fluid" style="width:28px;" alt="">
                                    </div>
                                </div>
                                <div class="col-6 col-md order-3 order-md-3 mt-2 mt-md-0 text-center">
                                    <p class="text-muted d-md-none mb-1">{{ $t('Giveaway')}}</p>
                                    <span v-if="price.giveaway" class="badge badge-soft-success font-size-12 ml-1 align-bottom">Yes</span>
                                    <span v-else class="badge badge-soft-warning font-size-12 ml-1 align-bottom">No</span>
                                </div>
                              <div class="col-6 col-md order-3 order-md-3 mt-2 mt-md-0 text-center">
                                <p class="text-muted d-md-none mb-1">{{ $t('Event')}}</p>
                                <span v-if="price.event" class="badge badge-soft-success font-size-12 ml-1 align-bottom">Yes</span>
                                <span v-else class="badge badge-soft-warning font-size-12 ml-1 align-bottom">No</span>
                              </div>
                                <div class="col-6 order-2 order-md-2 col-md mt-2 mt-md-0 text-center">
                                    <p class="text-muted d-md-none mb-1">{{ $t('Post type')}}</p>
                                    <h5 class="mb-0"> {{ (price.post_type.charAt(0).toUpperCase() + price.post_type.slice(1)).replace(/_/g, " ") }} </h5>
                                </div>
                                <div class="col-6 order-4 order-md-4 col-md mt-2 mt-md-0 text-center">
                                    <p class="text-muted d-md-none mb-1">{{ $t('Price')}}</p>
                                    <h5 class="mb-0"> {{ price.net_price.toLocaleString() }} <span style="font-size: 0.85em;">&euro;</span></h5>
                                </div>
                                <div class="col-6 order-1 order-md-5 col-md mt-2 mt-md-0 text-center">
                                    <p class="text-muted d-md-none mb-1">{{ $t('Quantity')}}</p>
                                    <h5 class="mb-0"> {{ price.quantity }} </h5>
                                </div>
                                <div class="order-5 order-md-6 col-6 mt-2 mt-md-0 col-md-auto text-center">
                                    <p class="text-muted d-md-none mb-1">{{ $t('Total price')}}</p>
                                    <div class="price-container d-inline d-md-block">
                                        <h5 class="mb-0"> {{ (price.net_price * price.quantity).toLocaleString() }} <span style="font-size: 0.85em;">&euro;</span></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sum-section mt-1">
                        <div class="row justify-content-end">
                            <div class="col-auto">
                                <h5>Sum:</h5>
                            </div>
                            <div class="col col-auto text-center">
                                <div class="price-container">
                                    <h5 class="mb-0 sum"> {{ sum(pack).toLocaleString() }} <span style="font-size: 0.85em;">&euro;</span></h5>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-end">
                            <div class="col-auto">
                                <h5>Package price:</h5>
                            </div>
                            <div class="col col-auto text-center">
                                <div class="price-container">
                                    <h4 class="mb-0 text-primary total-price d-inline">
                                        {{ pack.total_net_price.toLocaleString() }}
                                        <span style="font-size: 0.85em;">&euro;</span>
                                        <span class="total-badge badge badge-primary font-size-12 align-bottom"> {{ percentage(pack) }}%</span>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <PricePackageForm v-if="showNewModal" @saved="createPackage" @closed="closeNewModal" :package-number="packages.length + 1" />
        <PricePackageForm v-if="showEditModal" @saved="updatePackage" @closed="closeEditModal" :edit-package="editPackage" />


    </div>
</template>

<style scoped>
    .price-item {
        background-color: #fbfbfb;
        box-shadow: 0px 0px 0px #ffffff;
        border-radius: 4px;
    }
    .tab-section {
        border: 0px;
        border-radius: 0px;
        border-bottom: 1px solid #f6f6f6;
        margin-bottom: 0px;
        margin-top: 0px;
    }
    .tab-section:last-child {
        border: 0px;
    }
    .price-container {
        width: 170px;
    }
    .sum-section {
        margin-right: 5px;
        border-top: 2px solid #f6f6f6;
        padding-top: 10px;
    }
    .total-price {
        position: relative;
    }
    .total-badge {
        position: absolute;
        top: -5px;
    }
    .tab-section h5 {
        font-size: 0.9rem;
    }
    .sum {
        position: relative;
        display: inline-block;
    }
    .sum:before {
        position: absolute;
        content: "";
        left: 0;
        top: 40%;
        right: 0;
        border-top: 1px solid;
        border-color: inherit;
        -webkit-transform:rotate(-5deg);
        -moz-transform:rotate(-5deg);
        -ms-transform:rotate(-5deg);
        -o-transform:rotate(-5deg);
        transform:rotate(-11deg);
    }
    .pricing-header-row {
        border-bottom: 2px solid #f6f6f6;
        border-radius: 2px;
    }
    .social-image-container {
        height: 30px;
    }
</style>
